import React, { useMemo, useRef, useState } from 'react';
import './ProductGallery.css';
import '../scrollReveal.css';
import useScrollReveal from '../hooks/useScrollReveal';

import gallery1 from './works/gallery1.jpg';
import gallery2 from './works/gallery2.jpg';
import gallery3 from './works/gallery3.jpg';
import gallery4 from './works/gallery4.jpg';
import gallery5 from './works/gallery5.jpg';
import gallery6 from './works/gallery6.jpg';
import gallery7 from './works/gallery7.jpg';
import gallery8 from './works/gallery8.jpg';
import gallery9 from './works/gallery9.jpg';
import gallery10 from './works/gallery10.jpg';

const galleryItems = [
  { img: gallery1, title: 'Front Splitter Kit', tag: 'Aero & Body' },
  { img: gallery2, title: 'Carbon Fiber Diffuser', tag: 'Carbon Fiber' },
  { img: gallery3, title: 'Custom Intake Plenum', tag: 'Custom Builds' },
  { img: gallery4, title: 'Side Skirt Extension', tag: 'Aero & Body' },
  { img: gallery5, title: 'Dashboard Trim Panel', tag: 'Interior' },
  { img: gallery6, title: 'Rear Wing Assembly', tag: 'Aero & Body' },
  { img: gallery7, title: 'Carbon Center Console', tag: 'Interior' },
  { img: gallery8, title: 'Body Kit Prototype', tag: 'Custom Builds' },
  { img: gallery9, title: 'Brake Duct Housing', tag: 'Custom Builds' },
  { img: gallery10, title: 'Vented Hood Insert', tag: 'Aero & Body' },
];

const ProductGallery = () => {
  const items = useMemo(() => galleryItems, []);
  const scrollerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(true);
  const sectionRef = useScrollReveal();

  const getSlideWidth = () => {
    const el = scrollerRef.current;
    if (!el) return 0;
    const slide = el.querySelector('.slide');
    if (!slide) return 0;
    return slide.getBoundingClientRect().width + 20;
  };

  const updateStateFromScroll = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const slideWidth = getSlideWidth();
    if (!slideWidth) return;
    const idx = Math.round(el.scrollLeft / slideWidth);
    setActiveIndex(Math.max(0, Math.min(items.length - 1, idx)));
    setCanPrev(el.scrollLeft > 1);
    setCanNext(el.scrollLeft < el.scrollWidth - el.clientWidth - 1);
  };

  const scrollToIndex = (i) => {
    const el = scrollerRef.current;
    if (!el) return;
    const slideWidth = getSlideWidth();
    if (!slideWidth) return;
    el.scrollTo({ left: Math.max(0, Math.min(items.length - 1, i)) * slideWidth, behavior: 'smooth' });
  };

  return (
    <section className="gallery-section" ref={sectionRef}>
      <div className="gallery-container">
        <div className="section-header">
          <div className="section-label" data-reveal="fade-down">Portfolio</div>
          <h2 data-reveal="fade-up" data-delay="100">Recent Builds</h2>
          <p className="section-subtitle" data-reveal="fade-up" data-delay="200">
            A selection of custom aero, carbon fiber, and fabrication work for exotic and hypercar owners.
          </p>
        </div>

        <div className="slider-shell" data-reveal="zoom" data-delay="300">
          <button type="button" className="slider-arrow left" onClick={() => scrollToIndex(activeIndex - 1)} disabled={!canPrev} aria-label="Previous">‹</button>

          <div className="slider-scroller" ref={scrollerRef} onScroll={updateStateFromScroll}>
            {items.map((item, index) => (
              <div key={index} className="slide">
                <div className="slide-card">
                  <img src={item.img} alt={item.title} loading="lazy" />
                  <div className="slide-overlay">
                    <span className="slide-tag">{item.tag}</span>
                    <h3>{item.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button type="button" className="slider-arrow right" onClick={() => scrollToIndex(activeIndex + 1)} disabled={!canNext} aria-label="Next">›</button>
        </div>

        <div className="dots" data-reveal="fade-up" data-delay="400" role="tablist">
          {items.map((_, i) => (
            <button key={i} type="button" className={`dot ${i === activeIndex ? 'active' : ''}`} onClick={() => scrollToIndex(i)} aria-label={`Slide ${i + 1}`} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGallery;
